import Card from 'material-ui/Card'
import PropTypes from 'prop-types'
import React from 'react'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  card: {
    display: 'flex',
    borderBottom: '0.01rem solid black',
    '&:hover': {
      backgroundColor: 'lightgrey',
    },
  },
  content: {
    flex: 3,
    textAlign: 'left',
    marginLeft: '0.5rem',
  },
  header: {
    marginBottom: '0.25rem',
  },
  farmCardInfo: {
    '& p': {
      marginTop: 0,
      marginBottom: '0.25rem',
      fontSize: '0.75rem',
    },
  },
  imgContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  img: {
    minWidth: 100,
    maxWidth: 100,
    height: '100%',
    maxHeight: 100,
  },
  website: {
    textDecoration: 'none',
    '&:visited': {
      color: 'blue',
    },
  },
})

const FarmCard = ({
  classes,
  className,
  name,
  address,
  city,
  state,
  zip,
  farmId,
  website,
  story,
  commodities,
  changeActiveWindow,
  getFarmInfo,
}) => (
  <div>
    <Card
      className={`${classes.card}`}
      onClick={() => {
        getFarmInfo(farmId)
        changeActiveWindow(farmId)
      }}
    >
      <div className={classes.imgContent}>
        <img alt={name} className={classes.img} src={`https://images.producealliance.com/farm/${farmId}`} />
      </div>
      <div className={classes.content}>
        <Typography className={classes.header} component='p' type='body2'>
          {name}
        </Typography>
        <div className={classes.farmCardInfo}>
          <p>{address}</p>
          <p>{`${city}, ${state} ${zip}`}</p>
          <p><a className={classes.website} href={website} target='_blank'>Visit Website</a></p>
        </div>
      </div>
    </Card>
  </div>
)

export default withStyles(styles)(FarmCard)



// WEBPACK FOOTER //
// ./src/components/FarmCard.js